module.exports = __webpack_public_path__ + "media/images/top/topics-item-ca41950e14d1666f1a4c06f8ccb5cfca.webp";